import { SubscribeNowModalComponent } from 'src/app/components/subscribe-now-modal/subscribe-now-modal.component';
import { Router } from '@angular/router';
import { UserModel } from 'src/app/models/user.model';
import { UserService } from 'src/app/services/user.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonInfiniteScroll, ModalController } from '@ionic/angular';
import { followers, following } from 'src/app/constants/general.constant';
import { PaginatedResponse } from 'src/app/models/paginated-response.model';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';

@Component({
  selector: 'shc-user-friends-modal',
  templateUrl: './user-friends-modal.component.html',
  styleUrls: ['./user-friends-modal.component.scss'],
})
export class UserFriendsModalComponent implements OnInit {
  page: number;
  title: string;
  loading = false;
  @Input() type: string;
  @Input() userId: number;
  users: PaginatedResponse<UserModel>;
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;

  constructor(
    private userService: UserService,
    private errorService: ErrorHandlerService,
    private router: Router,
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
    this.page = 1;
    switch (this.type) {
      case followers:
        this.title = marker('User.Followers');
        this.getFollowers('');
        break;
      case following:
        this.title = marker('User.Following');
        this.getFollowing('');
        break;
      default:
        this.title = marker('User.Followers');
        this.getFollowers('');
        break;
    }
  }

  getFollowers(event) {
    this.loading= true;
    this.userService.userFollowers({ page: this.page, user_id: this.userId }).subscribe(res => {
      if (this.users && this.users.meta) {
        if (this.page === 1) {
          this.users = res;
        } else {
          this.users.meta = res.meta;
          this.users.data = [...this.users.data, ...res.data];
        }
      } else {
        this.users = res;
      }
      if (event) {
        event.target.complete();
      }
      this.page++;
      this.loading= false;
    }, error => {
      this.loading= false;
      this.errorService.handle(error);
    });
  }

  getFollowing(event) {
    this.loading= true;
    this.userService.userFollowing({ page: this.page, user_id: this.userId }).subscribe(res => {
      console.log(res);
      if (this.users && this.users.meta) {
        if (this.page === 1) {
          this.users = res;
        } else {
          this.users.meta = res.meta;
          this.users.data = [...this.users.data, ...res.data];
        }
      } else {
        this.users = res;
      }
      if (event) {
        event.target.complete();
      }
      this.page++;
      this.loading= false;
    }, error => {
      this.loading= false;
      this.errorService.handle(error);
    });
  }

  routeToUser(id: number) {
    this.modalCtrl.dismiss(null, null, 'userFriends').then(() => {
      this.router.navigate(['user', id]);
    });
  }

  async subscribeNow() {
    const modal = await this.modalCtrl.create({
      component: SubscribeNowModalComponent,
      cssClass: 'subscribeNow',
      id: 'subscribeNow',
      keyboardClose: true,
      mode: 'md',
      backdropDismiss: true,
      canDismiss: true
    });
    modal.onDidDismiss().then((data) => {
      // manage the data after the SubscribeNowModalComponent modal is closed
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }
  loadData(event): void {
    if (this.users.meta.current_page < this.users.meta.last_page) {
      if (this.type === followers) {
        this.getFollowers(event);
      } else if (this.type === following) {
        this.getFollowing(event);
      }
    } else {
      this.infiniteScroll.disabled = true;
    }
  }
}
